import Component from "@glimmer/component";
import { service } from "@ember/service";
import { Task, task } from "ember-concurrency";
import { arg, forbidExtraArgs } from "glesys-controlpanel/utils/arg";
import { arrayOf, shape, instanceOf, string } from "prop-types";
import { on } from "@ember/modifier";
import { t } from "ember-intl";
import Header from "glesys-controlpanel/components/g-modal/header";
import Body from "glesys-controlpanel/components/g-modal/body";
import Footer from "glesys-controlpanel/components/g-modal/footer";
import modalClose from "glesys-controlpanel/helpers/modal-close";
import GButton from "glesys-controlpanel/components/g-button";
import TaskForm from "glesys-controlpanel/components/task-form";
import Label from "glesys-controlpanel/components/label";
import GInput from "glesys-controlpanel/components/g-input";

@forbidExtraArgs
export default class ModalsDatabaseFirewallUpdateAccess extends Component {
  @service modal;

  @arg(
    shape({
      submitTask: instanceOf(Task),
      allowlist: arrayOf(string),
    }).isRequired,
  )
  params;

  allowlist = this.params.allowlist.join(", ");

  onChange = ({ allowlist }) => (this.allowlist = allowlist);

  onSubmitTask = task(async () => {
    if (await this.params.submitTask.perform(this.allowlist)) {
      this.modal.close();
    }
  });

  <template>
    <Header>{{t "component.modal.database-firewall-update-access.header"}}</Header>
    <Body>
      <p class="text-gray-500 pb-6">
        {{t "component.modal.database-firewall-update-access.description"}}
      </p>
      <TaskForm id="update-firewall-form" @onChange={{this.onChange}} @task={{this.onSubmitTask}}>
        <Label>{{t "component.modal.database-firewall-update-access.allowed-list-label"}}</Label>
        <GInput
          data-test-modal-database-firewall-update-access-input
          name="allowlist"
          value={{this.allowlist}}
          placeholder={{t "component.modal.database-firewall-update-access.input-placeholder"}}
        />
      </TaskForm>
    </Body>
    <Footer>
      <GButton class="mr-2" data-test-cancel-button @color="gray" {{on "click" (modalClose)}}>
        {{t "button.close"}}
      </GButton>
      <GButton
        data-test-modal-database-firewall-update-update-button
        @type="submit"
        @color="blue"
        form="update-firewall-form"
      >
        {{t "button.update"}}
      </GButton>
    </Footer>
  </template>
}
